import React from "react";
import SearchMandub from "./SearchMandub";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import Time from "react-time-format";

const FormMandub = ({ onNewPage, onSaveChange, savekrdn }) => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            AddProChange,
            MM_zhamara,
            MM_joredraw,
            MM_zhmaraybarez,
            MM_openUpdate,
            MM_search_wasl,
            MM_barwar,
            MM_del_dis,
            MM_nawebarez,
            MM_qarzeKonDolar,
            MM_qarzeKonID,
            MM_onSaveMoney,
            MM_getParaDataBySearchMoney,
            MM_setSearchMonyWakilEmpty,
            MM_brepara,
            MM_getPrint,
            MM_getWakilDataBySearchMoney,
            MM_createNewMony,
            MM_toggler,
            MM_wasleShareka,
            MM_save,
            MM_nawewargr,
            MM_open,
            L_user,
            MM_wasl,
            MM_updtate_para,
            MM_pageminsone,
            MM_pageplusone,
            MM_inputtogler,
            PD_show,
            PD_parayesta_RRR,
            PD_showrasid,
            role,
            MM_note,
            MM_wakilSearch,
            MM_qarzeKonR,
            MM_DinartoRemembi_In_Balance,
            MM_DolartoRemembi_In_Balance,
            MM_DolarTR,
            MM_DinarTR,
            MM_getParaDataBySearcInvoice,
            MM_kasSuggestions,
            MM_kasCursor,
            MM_kasNameHandle,
            MM_kasListKeydown,
            MM_kasSuggestionSelected
          } = value;
          const renderdate = (kat) => {
            const monthname = [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12"
            ];
            const date = new Date(kat);

            return `${date.getDate()}/${
              monthname[date.getMonth()]
            }/${date.getFullYear()}`;
          };
          return (
            <>
              <div className="row ">
                <div className="col-1"></div>
                <div className="col-12 col-lg-4 ">
                  {/* Search take money */}
                  <SearchMandub />
                </div>
                <div className="col-1"></div>
                {/* Form take moneyy */}
                <div className="col-lg-6 text-warning col-12 ">
                  <div
                    className="card card-warning "
                    style={{ backgroundColor: "#2C3539" }}
                  >
                    <div
                      className="card-header p-1 border-bottom border-warning"
                      style={{ backgroundColor: "#2C3539" }}
                    >
                      <h2 className="card-title tc">مافی.کۆمپانیا</h2>
                    </div>

                    <div className="card-body">
                      <form>
                        <div className="row">
                          <div className="col-3 text-right mt2">
                            <button
                              disabled={MM_del_dis == true ? true : null}
                              onClick={MM_inputtogler}
                              className="btn btn-info mt4"
                            >
                              <i className="far fa-calendar-alt white "></i>
                            </button>
                          </div>

                          <div
                            className={`${
                              MM_toggler == true
                                ? "col-sm-6 text-right"
                                : "col-sm-3 text-right"
                            }`}
                          >
                            <div className="form-group">
                              <label className="font-weight-bold f4">
                                بەروار
                              </label>
                              {MM_toggler == false ? (
                                <input
                                  type="text"
                                  name="MM_barwar"
                                  value={
                                    MM_search_wasl == true || MM_save == true
                                      ? renderdate(MM_barwar)
                                      : renderdate(Date.now())
                                  }
                                  className="form-control text-right font-weight-bold"
                                />
                              ) : (
                                <input
                                  type="datetime-local"
                                  name="MM_barwar"
                                  value={MM_barwar}
                                  onChange={AddProChange}
                                  className="form-control text-right font-weight-bold tc btn btn-info"
                                  style={{ margin: "0px 8px" }}
                                />
                              )}
                            </div>
                          </div>
                          {MM_toggler == false ? (
                            <div className="col-sm-3 text-right">
                              <div className="form-group">
                                <label className="font-weight-bold f4">
                                  کات
                                </label>
                                {MM_search_wasl == true || MM_save == true ? (
                                  <p className="font-weight-bold bg-white p-2 border rounded tc">
                                    <Time
                                      value={MM_barwar}
                                      format="hh:mm:ss"
                                      style={{ color: "black" }}
                                    />
                                  </p>
                                ) : (
                                  <p className="font-weight-bold bg-white p-2 border rounded tc">
                                    <Time
                                      value={Date.now()}
                                      format="hh:mm:ss"
                                      style={{ color: "black" }}
                                    />
                                  </p>
                                )}
                              </div>
                            </div>
                          ) : null}

                          <div className="col-sm-3 text-right">
                            <div className="form-group">
                              <label className="font-weight-bold f4">
                                ژمارە
                              </label>
                              <input
                                type="text"
                                name="MM_zhamara"
                                disabled={MM_del_dis == true ? true : null}
                                value={MM_zhamara}
                                onKeyPress={(event) =>
                                  event.key == "Enter"
                                    ? MM_getParaDataBySearchMoney(event)
                                    : null
                                }
                                onChange={AddProChange}
                                className={`form-control text-right font-weight-bold ${
                                  MM_search_wasl == true || MM_save == true
                                    ? "bg-danger text-white"
                                    : ""
                                }`}
                              />
                            </div>
                            <div className="row">
                              <div className="col-8 text-right ">
                                <label className="form-check-label font-weight-bold f3">
                                  کۆمپانیاکان
                                </label>
                              </div>
                            </div>
                            <hr />
                            <br />
                          </div>
                          {/* <div className="col-3 text-right mt4">
                            <div className="row">
                              <div className="col-4"></div>
                              <div className="col-4">
                                <div className="form-group ">
                                  <button
                                    disabled={MM_del_dis == true ? true : null}
                                    onClick={MM_setSearchMonyWakilEmpty}
                                    className="btn btn-dark"
                                  >
                                    <i className="fas fa-search-plus"></i>
                                  </button>
                                </div>
                              </div>
                              <div className="col-4"></div>
                            </div>
                          </div> */}
                          <div className="col-1 text-right mt-4">
                            {/* {role == "admin" ? (
                              PD_show == false ? (
                                <button
                                  onClick={(e) => PD_showrasid(e, L_user._id)}
                                  className="btn btn-primary mt-3"
                                  style={{ backgroundColor: "orange" }}
                                >
                                  <i className="fas fa-eye"></i>
                                </button>
                              ) : (
                                <button
                                  onClick={PD_showrasid}
                                  className="btn btn-primary mt-3"
                                  style={{ backgroundColor: "orange" }}
                                >
                                  <i className="fas fa-eye-slash"></i>
                                </button>
                              )
                            ) : null} */}
                          </div>
                          <div className="col-sm-4 text-right  ">
                            {/* <div className="form-group ">
                              <label className="font-weight-bold f4">
                                RRR ڕەسیدی ئێستا بە{" "}
                              </label>
                              {PD_show == false ? (
                                <NumberFormat
                                  value={"0"}
                                  displayType={"text"}
                                  className="form-control f4 text-right font-weight-bold card-header p-1  text-white bg-info"
                                  thousandSeparator={true}
                                  prefix={"Y"}
                                />
                              ) : (
                                <NumberFormat
                                  value={PD_parayesta_RRR}
                                  displayType={"text"}
                                  className="form-control f4 text-right font-weight-bold card-header p-1  text-white bg-info"
                                  thousandSeparator={true}
                                />
                              )}
                            </div> */}
                          </div>
                          <div className="col-sm-4 text-right">
                            <div
                              className="form-group"
                              style={{ position: "relative" }}
                            >
                              <label className="font-weight-bold f4">
                                ناوی بەرێز
                              </label>
                              <input
                                type="text"
                                name="MM_nawebarez"
                                disabled={MM_del_dis == true ? true : null}
                                onChange={MM_kasNameHandle}
                                onKeyDown={MM_kasListKeydown}
                                autoComplete="off"
                                value={MM_nawebarez}
                                className="form-control text-right font-weight-bold"
                              />
                              {MM_del_dis != true &&
                                MM_kasSuggestions &&
                                MM_kasSuggestions.length !== 0 && (
                                  <ul
                                    dir="rtl"
                                    style={{
                                      position: "absolute",
                                      top: "100%",
                                      left: 0,
                                      right: 0,
                                      maxHeight: "250px",
                                      overflowY: "auto",
                                      zIndex: 1000,
                                      backgroundColor: "#fff",
                                      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                                      borderRadius: "4px",
                                      marginTop: "2px"
                                    }}
                                    className="list-group"
                                  >
                                    {MM_kasSuggestions.map((item, idx) => (
                                      <li
                                        className="list-group-item"
                                        key={item._id || idx}
                                        onClick={() =>
                                          MM_kasSuggestionSelected(item)
                                        }
                                        style={{
                                          cursor: "pointer",
                                          padding: "8px 12px",
                                          borderBottom: "1px solid #dee2e6",
                                          textAlign: "right",
                                          color: "#000",
                                          backgroundColor:
                                            MM_kasCursor === idx
                                              ? "#d4e9ff"
                                              : "#fff"
                                        }}
                                      >
                                        <div className="font-weight-bold">
                                          {item.Name}
                                        </div>
                                        <small
                                          dir="ltr"
                                          style={{
                                            display: "block",
                                            textAlign: "right",
                                            color: "#6c757d"
                                          }}
                                        >
                                          {item.code} | {item.phone}
                                        </small>
                                      </li>
                                    ))}
                                  </ul>
                                )}
                            </div>
                          </div>

                          <div className="col-3 text-right">
                            <div className="form-group">
                              <label className="font-weight-bold f4">
                                ژ.بەڕێز
                              </label>
                              <input
                                type="text"
                                name="MM_zhmaraybarez"
                                onClick={MM_setSearchMonyWakilEmpty}
                                disabled={MM_del_dis == true ? true : null}
                                onChange={AddProChange}
                                onKeyPress={(event) =>
                                  event.key == "Enter"
                                    ? MM_getWakilDataBySearchMoney(event)
                                    : null
                                }
                                value={
                                  MM_zhmaraybarez == 0 ? "" : MM_zhmaraybarez
                                }
                                className="form-control text-right font-weight-bold"
                              />
                            </div>
                          </div>
                          
                          <div className="row">
                             <div className="col-3 text-right"></div>
                            <div className="col-3 text-right">
                              <div className="form-group">
                                <label className="font-weight-bold f5">
                                  ژمارەی پسوولە
                                </label>
                                <input
                                  type="text"
                                  name="MM_wasleShareka"
                                  disabled={MM_del_dis == true ? true : null}
                                  onChange={AddProChange}
                                  onKeyPress={(event) =>
                                    event.key == "Enter"
                                      ? MM_getParaDataBySearcInvoice(event)
                                      : null
                                  }
                                  value={
                                    MM_wasleShareka == 0 ? "" : MM_wasleShareka
                                  }
                                  className="form-control text-right font-weight-bold"
                                />
                              </div>
                            </div>
                            
                            <div className="col-3 text-right">
                              <div className="form-group">
                                <label className={`font-weight-bold f6 ${MM_DinarTR ? "text-danger" : "text-warning"}`}>
                                  {/* <button
                                    className="btn btn-danger  btn-sm"
                                    onClick={MM_DinartoRemembi_In_Balance}
                                    disabled={MM_del_dis == true ? true : null}
                                  >
                                    I
                                  </button> */}
                                  ID قەرزی ئەستۆ بە{" "}
                                </label>
                                <NumberFormat
                                  value={Number(MM_qarzeKonID).toFixed(2)}
                                  displayType={"text"}
                                  className="form-control text-right font-weight-bold p-2"
                                  thousandSeparator={true}
                                  prefix={"ID"}
                                />
                              </div>
                            </div>
                            {/* <div className="col-3 text-right">
                              <div className="form-group">
                                <label className="font-weight-bold f5">
                                  R قەرزی ئەستۆ بە{" "}
                                </label>
                                <NumberFormat
                                  value={Number(MM_qarzeKonR).toFixed(2)}
                                  displayType={"text"}
                                  className="form-control text-right font-weight-bold p-2"
                                  thousandSeparator={true}
                                  prefix={"R "}
                                />
                              </div>
                            </div> */}
                            <div className="col-3 text-right">
                              <div className="form-group">
                                <label className={`font-weight-bold f6 ${MM_DolarTR ? "text-danger" : "text-warning"}`}>
                                  {/* <button
                                    className="btn btn-success  btn-sm"
                                    onClick={MM_DolartoRemembi_In_Balance}
                                    disabled={MM_del_dis == true ? true : null}
                                  >
                                    $
                                  </button> */}
                                  $ قەرزی ئەستۆ بە{" "}
                                </label>
                                <NumberFormat
                                  value={Number(MM_qarzeKonDolar).toFixed(2)}
                                  displayType={"text"}
                                  className="form-control text-right font-weight-bold p-2"
                                  thousandSeparator={true}
                                  prefix={"$"}
                                />
                              </div>
                            </div>
                            
                          </div>
                          <div className="col-4 text-right">
                            <label className="font-weight-bold f4">
                              ناوی وەرگر
                            </label>
                            <select
                              className={`form-control text-right font-weight-bold selectpicker pull-right ${
                                MM_nawewargr == "ئەنوەر"
                                  ? "bg-success text-white"
                                  : `${
                                      MM_nawewargr == "یوسف"
                                        ? "bg-danger text-white"
                                        : ""
                                    }`
                              } `}
                              disabled={MM_del_dis == true ? true : null}
                              onChange={AddProChange}
                              name="MM_nawewargr"
                              value={MM_nawewargr != null ? MM_nawewargr : ""}
                            >
                              <option className="ml5">...ناوی وەرگر</option>
                              <option>ئەنوەر</option>
                              <option>یوسف</option>
                            </select>
                          </div>
                          <div className="col-sm-4 text-right">
                            <label className="font-weight-bold f4">
                              جۆری دراو
                            </label>
                            <select
                              className={`form-control text-right font-weight-bold selectpicker pull-right ${
                                MM_joredraw == "دۆلار"
                                  ? "bg-success text-white"
                                  : `${
                                      MM_joredraw == "دینار"
                                        ? "bg-danger text-white"
                                        : MM_joredraw == "ڕیمێمبی"
                                        ? "bg-info text-white"
                                        : ""
                                    }`
                              } `}
                              disabled={MM_del_dis == true ? true : null}
                              onChange={AddProChange}
                              name="MM_joredraw"
                              value={MM_joredraw != null ? MM_joredraw : ""}
                            >
                              <option className="ml5">..جۆری دراو</option>
                              <option>دۆلار</option>
                              <option>دینار</option>
                              {/* <option>ڕیمێمبی</option> */}
                            </select>
                          </div>
                          <div className="col-sm-4 text-right">
                            <div className="form-group">
                              <label className="font-weight-bold f4">
                                بڕی پارە
                              </label>
                              <NumberFormat
                                displayType="input"
                                thousandSeparator={true}
                                name="MM_brepara"
                                id="MM_brepara_input"
                                onChange={AddProChange}
                                disabled={MM_del_dis == true ? true : null}
                                value={MM_brepara == 0 ? "" : MM_brepara}
                                className="form-control text-right font-weight-bold bg-info text-white"
                              />
                            </div>
                          </div>
                          {/* <div className="col-1 text-right"></div> */}
                          <div className="col-sm-8 mt4">
                            <button
                              className="btn btn-dark p3 px-4"
                              style={{
                                backgroundColor: "#00695c",
                                border: "1px solid #00695c"
                              }}
                              disabled={MM_open == true ? true : null}
                              onClick={MM_pageminsone}
                            >
                              <i className="fas fa-caret-left f4"></i>
                            </button>
                            <button
                              className="btn btn-dark p3 px-4 ml3"
                              style={{
                                backgroundColor: "#00695c",
                                border: "1px solid #00695c"
                              }}
                              disabled={MM_open == true ? true : null}
                              onClick={MM_pageplusone}
                            >
                              <i className="fas fa-caret-right f4"></i>
                            </button>
                            {MM_search_wasl == true ? (
                              <>
                                {MM_open == null ? (
                                  <button
                                    onClick={(e) =>
                                      MM_openUpdate(L_user._id, e, MM_wasl._id)
                                    }
                                    className="btn btn-md btn-warning px-4 ml3"
                                    style={{
                                      backgroundColor: "silver",
                                      border: "1px solid silver"
                                    }}
                                  >
                                    <i className="fas fa-lock"></i>
                                  </button>
                                ) : (
                                  <button
                                    onClick={(e) =>
                                      MM_updtate_para(e, MM_wasl, MM_wasl)
                                    }
                                    className="btn btn-md btn-primary px-4 ml3"
                                    style={{ backgroundColor: "navy" }}
                                  >
                                    <i className="fas fa-edit "></i>
                                  </button>
                                )}
                                <Link to="/print-mandub">
                                  <button
                                    onClick={MM_getPrint}
                                    type="button"
                                    className="btn btn-md btn-primary px-4 ml3"
                                    style={{
                                      backgroundColor: "purple",
                                      border: "1px solid purple"
                                    }}
                                  >
                                    <i className=" fas fa-print fa-lg white "></i>
                                  </button>
                                </Link>
                              </>
                            ) : MM_save == null ? (
                              <button
                                type="button"
                                onClick={() => {
                                  MM_onSaveMoney();
                                  onSaveChange(
                                    MM_nawebarez,
                                    MM_zhmaraybarez,
                                    MM_wasleShareka,
                                    MM_nawewargr,
                                    MM_brepara,
                                    MM_joredraw,
                                    MM_note
                                  );
                                }}
                                className="btn btn-md btn-success px-4 ml3"
                              >
                                <i className="far fa-save fa-lg"></i>
                              </button>
                            ) : null}
                            <button
                              type="button"
                              onClick={() => {
                                MM_createNewMony();
                                onNewPage();
                              }}
                              disabled={MM_open ? true : null}
                              className={`btn btn-md btn-${
                                (MM_wakilSearch && !MM_search_wasl) || MM_open
                                  ? "danger"
                                  : "primary"
                              } px-4 ml3`}
                            >
                              <i className="far fa-file fa-lg"></i>
                            </button>
                            <Link to="/print-mandub">
                              {MM_save || savekrdn ? (
                                <>
                                  <button
                                    onClick={MM_getPrint}
                                    type="button"
                                    className="btn btn-md btn-primary px-4 ml3"
                                    style={{
                                      backgroundColor: "purple",
                                      border: "1px solid purple"
                                    }}
                                  >
                                    <i className=" fas fa-print fa-lg white "></i>
                                  </button>
                                  {MM_open == null ? (
                                    <button
                                      onClick={(e) =>
                                        MM_openUpdate(
                                          L_user._id,
                                          e,
                                          MM_wasl._id
                                        )
                                      }
                                      className="btn btn-md btn-warning px-4 ml3"
                                      style={{
                                        backgroundColor: "silver",
                                        border: "1px solid silver"
                                      }}
                                    >
                                      <i className="fas fa-lock"></i>
                                    </button>
                                  ) : (
                                    <button
                                      onClick={(e) =>
                                        MM_updtate_para(e, MM_wasl, MM_wasl)
                                      }
                                      className="btn btn-md btn-primary px-4 ml3"
                                      style={{ backgroundColor: "navy" }}
                                    >
                                      <i className="fas fa-edit "></i>
                                    </button>
                                  )}
                                </>
                              ) : null}
                            </Link>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};
export default FormMandub;
